module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/chart-bar-3-1d98ef8cda06e060e68ac2e229fb46f4.svg";